const features = [
  {
    icon: 'ri-movie-2-line',
    tag: '暑期档精选',
    title: '暑期档必看大片合集',
    desc: '精选2024夏季最热院线大片，动作、科幻、喜剧全收录，每一部都值得反复观看。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20movie%20collage%20with%20warm%20golden%20sunlight%2C%20film%20reel%20and%20popcorn%20on%20dark%20theater%20background%2C%20dramatic%20lighting%2C%20rich%20contrast%2C%20movie%20marquee%20aesthetic%2C%20vintage%20cinema%20vibe%2C%20no%20text%2C%20artistic%20composition&width=800&height=500&seq=carousel-summer-2026&orientation=landscape',
  },
  {
    icon: 'ri-star-line',
    tag: '高分推荐',
    title: '豆瓣8分以上神剧推荐',
    desc: '口碑炸裂的高分剧集合集，每部都是豆瓣8分以上的品质保证，追剧党不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20literary%20film%20aesthetic%20with%20vintage%20movie%20posters%20on%20a%20warm%20brick%20wall%2C%20soft%20ambient%20lighting%2C%20artistic%20cinema%20culture%20scene%2C%20golden%20and%20burgundy%20tones%2C%20film%20critic%20atmosphere%2C%20no%20people%2C%20sophisticated%20composition&width=800&height=500&seq=carousel-douban-2026&orientation=landscape',
  },
  {
    icon: 'ri-flag-2-line',
    tag: '华语佳作',
    title: '2024年度高分华语片',
    desc: '今年华语影坛的惊喜之作，从剧情到制作全面升级，见证华语电影的新高度。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20Chinese%20cinema%20scene%20with%20traditional%20red%20lanterns%20and%20modern%20film%20elements%2C%20warm%20dramatic%20lighting%2C%20elegant%20calligraphy%20brush%20strokes%20in%20background%2C%20cinematic%20mood%2C%20rich%20crimson%20and%20gold%20palette%2C%20no%20text%2C%20refined%20aesthetic&width=800&height=500&seq=carousel-chinese-2026&orientation=landscape',
  },
  {
    icon: 'ri-psychotherapy-line',
    tag: '悬疑烧脑',
    title: '悬疑烧脑佳作精选',
    desc: '层层反转、细思极恐的悬疑神作合集，每一部都能让你猜不到结局，烧脑爱好者必收。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20film%20noir%20atmosphere%20with%20dramatic%20shadows%20and%20fog%2C%20detective%20desk%20with%20old%20photographs%20and%20magnifying%20glass%2C%20dark%20moody%20cinematic%20lighting%2C%20vintage%20thriller%20aesthetic%2C%20deep%20blues%20and%20amber%20highlights%2C%20no%20people%2C%20suspenseful%20composition&width=800&height=500&seq=carousel-mystery-2026&orientation=landscape',
  },
  {
    icon: 'ri-user-smile-line',
    tag: '合家欢',
    title: '合家欢动画电影专场',
    desc: '适合全家一起看的高分动画电影，温情治愈又充满想象力，大人小孩都爱看。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20whimsical%20animation%20studio%20workspace%20with%20character%20sketches%20and%20storyboards%2C%20warm%20playful%20lighting%2C%20creative%20artistic%20atmosphere%2C%20vibrant%20yet%20soft%20color%20palette%2C%20hand%20drawn%20illustration%20style%2C%20no%20people%2C%20charming%20cinematic%20aesthetic&width=800&height=500&seq=carousel-animation-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            焦点推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500">精选优质影视内容，发现你的下一部心头好</p>
        </div>

        <div className="flex flex-col gap-6 max-w-5xl mx-auto">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col md:flex-row gap-5 bg-background-50 rounded-xl overflow-hidden group cursor-pointer"
            >
              <div className="w-full md:w-[280px] lg:w-[340px] shrink-0 h-48 md:h-auto relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                    <i className={`${item.icon} text-xs w-4 h-4 flex items-center justify-center`}></i>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
                <a
                  href="#index"
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看专题
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}